/* eslint-disable react/no-find-dom-node */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Group from '../Group';
import Button from '../Button';
import Text from '../Text';
import Image from '../Image';
import Lottie from '../LottieControl';
import firebase, { documentSharingListner } from '../../firebase';
import theme, { rem } from '../../theme';

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
`;

const StyledTextIntro = styled(Text)`
  margin-bottom: ${rem(20)};
`;

const StyledImage = styled(Image)`
  margin-bottom: ${rem(20)};
  width: 100%;
  height: ${rem(250)};
  object-fit: contain;
`;

const StyledText = styled(Text)`
  margin-bottom: ${rem(10)};
`;

const StyledContentWrapper = styled(Group)`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-between;
`;

const StyledButtonGroup = styled(Group)`
  margin-top: ${rem(20)};

  button {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: ${rem(20)};
    width: ${rem(350)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledMessage = styled(Text)`
  background: ${theme.color.dark[40]};
  padding: ${rem(8)} ${rem(10)};
  border-radius: ${rem(5)};
}
`;

const StyledLoading = styled(Lottie)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledGroup = styled(Group)`
  flex-direction: column;
  margin-bottom: ${rem(10)};

  &:last-child {
    margin-bottom: 0;
  }
`;

/** todo */
const removeFile = props => {
  const { currentId, fileId, documentId, closeModals } = props;

  //States
  const [loading, setLoading] = useState(true);
  const [documentData, setDocumentData] = useState({});
  const [image, setImage] = useState();

  //Translation
  const [t] = useTranslation(['modal', 'button']);

  useEffect(() => {
    //getDashboardData();
    fileId && getFileData();
    document.getElementById('globalModal').firstElementChild.style.height =
      'auto';
    document.getElementById('globalModal').firstElementChild.style.width =
      '25rem';
  }, []);

  /** Get all the dashboard data */
  const getFileData = () => {
    documentSharingListner
      .child(currentId)
      .child('documents')
      .child(documentId)
      .once('value', snapshot => {
        if (snapshot.val()) {
          setDocumentData(snapshot.val());
          setLoading(false);
        }
      });
  };

  /** Handle update */
  const handleRemove = () => {
    documentSharingListner
      .child(currentId)
      .child('documents')
      .child(documentId)
      .remove()
      .then(() => {
        firebase
          .storage()
          .ref()
          .child('documents')
          .child(currentId)
          .child(fileId)
          .delete()
          .then(() => {
            documentSharingListner
              .child(currentId)
              .child('totalItems')
              .transaction(function(totalItems) {
                return (totalItems || 1) - 1;
              });
          });
        closeModals();
      });
  };

  /** Return Chat messages */
  return loading ? (
    <StyledLoading animation='loading' animationWidth={400} />
  ) : (
    <StyledWrapper>
      <StyledContentWrapper fullwidth>
        <StyledText
          align='center'
          text={t('modal:removefile.title')}
          textColor='#fff'
          textStyle='h3'
          tag='h1'
        />

        <StyledTextIntro
          align='center'
          text={t('modal:removefile.text', { name: documentData.name })}
          textColor='#fff'
          textStyle='h6'
          tag='p'
        />

        <StyledButtonGroup fullwidth>
          <Button
            variant='contained'
            onClick={() => {
              handleRemove();
            }}
            bgColor={theme.color.danger}
            text={{
              align: 'center',
              text: t('button:remove.text'),
              textColor: '#fff',
            }}
          />
          <Button
            variant='contained'
            text={{
              align: 'center',
              text: t('button:cancel.cancel'),
              textColor: '#fff',
            }}
            onClick={() => {
              closeModals();
            }}
            bgColor={theme.color.cancel}
          />
        </StyledButtonGroup>
      </StyledContentWrapper>
    </StyledWrapper>
  );
};

removeFile.propTypes = {
  /** Current Id */
  currentId: PropTypes.string,
  /** FIle Id */
  fileId: PropTypes.string,
  /** Close function for the modal */
  closeModals: PropTypes.func,
};

removeFile.defaultProps = {
  currentId: null,
  fileId: null,
  closeModals: null,
};

export default removeFile;
